import {
  CAPTAIN_ACCESS_FEATURE_FLAGS,
  CAPTAIN_ADDITIONAL_FEATURE_FLAGS,
  CAPTAIN_TOOLS_FEATURE_FLAGS,
} from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from '../../../helper/URLHelper';

import CaptainPageRouteView from './pages/CaptainPageRouteView.vue';
import AssistantsIndexPage from './pages/AssistantsIndexPage.vue';
import AssistantEmptyStateIndex from './assistants/Index.vue';

import AssistantExperienceIndex from './assistants/experience/Index.vue';
import AssistantInboxesIndex from './assistants/inboxes/Index.vue';
import AssistantPlaygroundIndex from './assistants/playground/Index.vue';
import AssistantScenariosIndex from './assistants/scenarios/Index.vue';
import DocumentsIndex from './documents/Index.vue';
import ResponsesIndex from './responses/Index.vue';
import ResponsesPendingIndex from './responses/Pending.vue';
import CustomToolsIndex from './tools/Index.vue';

const captainAccessMeta = {
  permissions: ['administrator', 'agent'],
  featureFlag: CAPTAIN_ACCESS_FEATURE_FLAGS,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

const captainAdditionalMeta = {
  ...captainAccessMeta,
  featureFlag: CAPTAIN_ADDITIONAL_FEATURE_FLAGS,
};

const captainAdminMeta = {
  ...captainAccessMeta,
  permissions: ['administrator'],
};

const captainToolsMeta = {
  ...captainAccessMeta,
  featureFlag: CAPTAIN_TOOLS_FEATURE_FLAGS,
};

const redirectToIdentityWorkspace = to => ({
  name: 'captain_assistants_experience_index',
  params: {
    accountId: to.params.accountId,
    assistantId: to.params.assistantId,
  },
  query: {
    ...to.query,
    section: 'identity',
  },
});

const redirectToOverviewWorkspace = to => ({
  name: 'captain_assistants_experience_index',
  params: {
    accountId: to.params.accountId,
    assistantId: to.params.assistantId,
  },
  query: {
    ...to.query,
    section: 'overview',
  },
});

const assistantRoutes = [
  {
    path: frontendURL('accounts/:accountId/captain/tools'),
    component: CustomToolsIndex,
    name: 'captain_account_tools_index',
    meta: captainToolsMeta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/captain/assistants/:assistantId/agent'
    ),
    redirect: to => ({
      name: 'captain_assistants_experience_index',
      params: {
        accountId: to.params.accountId,
        assistantId: to.params.assistantId,
      },
    }),
    meta: captainAccessMeta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/agent'),
    component: AssistantExperienceIndex,
    name: 'captain_assistants_experience_index',
    meta: captainAccessMeta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/overview'),
    name: 'captain_assistants_overview_index',
    redirect: redirectToOverviewWorkspace,
    meta: captainAccessMeta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/faqs'),
    component: ResponsesIndex,
    name: 'captain_assistants_responses_index',
    meta: captainAccessMeta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/documents'),
    component: DocumentsIndex,
    name: 'captain_assistants_documents_index',
    meta: captainAccessMeta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/tools'),
    name: 'captain_tools_index',
    redirect: to => ({
      name: 'captain_account_tools_index',
      params: { accountId: to.params.accountId },
      query: {
        ...to.query,
        assistant_id: String(to.params.assistantId),
      },
    }),
    meta: captainToolsMeta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/scenarios'),
    component: AssistantScenariosIndex,
    name: 'captain_assistants_scenarios_index',
    meta: captainAdditionalMeta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/playground'),
    component: AssistantPlaygroundIndex,
    name: 'captain_assistants_playground_index',
    meta: captainAdminMeta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/inboxes'),
    component: AssistantInboxesIndex,
    name: 'captain_assistants_inboxes_index',
    meta: captainAdminMeta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/faqs/pending'),
    component: ResponsesPendingIndex,
    name: 'captain_assistants_responses_pending',
    meta: captainAccessMeta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/settings'),
    name: 'captain_assistants_settings_index',
    redirect: redirectToIdentityWorkspace,
    meta: captainAccessMeta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/captain/:assistantId/settings/guardrails'
    ),
    name: 'captain_assistants_guardrails_index',
    redirect: redirectToIdentityWorkspace,
    meta: captainAdditionalMeta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/captain/:assistantId/settings/guidelines'
    ),
    name: 'captain_assistants_guidelines_index',
    redirect: redirectToIdentityWorkspace,
    meta: captainAdditionalMeta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/assistants'),
    component: AssistantEmptyStateIndex,
    name: 'captain_assistants_create_index',
    meta: captainAccessMeta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:navigationPath'),
    component: AssistantsIndexPage,
    name: 'captain_assistants_index',
    meta: captainAccessMeta,
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/captain'),
    component: CaptainPageRouteView,
    redirect: to => {
      return {
        name: 'captain_assistants_create_index',
        params: {
          ...to.params,
        },
      };
    },
    children: [...assistantRoutes],
  },
];
